/**
 * Csv Schema of PontaSla
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {PontaSla} from '@/model/resource/PontaSla'

/* TODO: review generated schema */
export class CsvPontaSlaSchema extends Schema {
  readonly name = 'CsvPontaSla'

  readonly fieldSet: FieldSet<PontaSla> = {
    idPontaSlaPk: schema => schema.model.idPontaSlaPk,
    abreviacao: schema => schema.model.abreviacao,
    uf: schema => schema.model.uf,
    naCapital: schema => Helper.bool(schema.model.naCapital),
    cidade: schema => schema.model.cidade,
  }
}
